import { useRecoilState, useRecoilValue } from 'recoil';

import { FilterModalTypes } from '../../components/FilterModal';
import { applyFilterFromOutside } from '../../components/FilterModal/handlers/applyFilterFromOutside';

import {
  orderHistoryDateFilterState,
  OrderHistoryDateFilterStateProps,
  orderHistoryFiltersAtom,
} from './atom';
import { dateFilterFilter } from './filters';

export const useOrderHistoryStateActions = () => {
  const orderDateFilterFieldName = dateFilterFilter.fieldName;
  const { options } = useRecoilValue(orderHistoryDateFilterState);
  const [{ availableFilters, selectedFilters }, setAssetsFiltersAtom] =
    useRecoilState(orderHistoryFiltersAtom);

  const getCorrectSelectedFilter = (): FilterModalTypes.SelectedFiltersProps | undefined => {
    return selectedFilters.find(({ fieldName }) => fieldName === orderDateFilterFieldName);
  };

  const getCorrectAvailableFilter = (): FilterModalTypes.FilterType | undefined => {
    return availableFilters.find(({ fieldName }) => fieldName === orderDateFilterFieldName);
  };

  const selectedOption = getCorrectSelectedFilter();
  const availableFilter = getCorrectAvailableFilter();

  const setSelectedDateFilterOption = (
    newSelection: OrderHistoryDateFilterStateProps['optionSelected']
  ) => {
    setAssetsFiltersAtom((prevFilters) => {
      const filtersWithOrderDate = applyFilterFromOutside(prevFilters, orderDateFilterFieldName, [
        newSelection.value,
      ]);
      return applyFilterFromOutside(filtersWithOrderDate, 'sendDate', {});
    });
  };

  return {
    options,
    selectedOption,
    availableFilter,
    setSelectedDateFilterOption,
  };
};
